import { render, staticRenderFns } from "./your-account.vue?vue&type=template&id=65399a13&scoped=true&"
import script from "./your-account.vue?vue&type=script&lang=js&"
export * from "./your-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65399a13",
  null
  
)

export default component.exports